import {createSlice} from '@reduxjs/toolkit';
import {updateNotificationsMobileNumber} from "../../api/supplier/update-notifications-mobile-number";

export const updateSupplierNotificationsMobileNumberSlice = createSlice({
    name: 'supplier/update-notifications-mobile-number',
    initialState: {
        request: false,
        messageTitle: '',
        message: '',
        outcome: 'pending',
    },
    reducers: {
        showError(state, action) {
            state.request = false;
            state.outcome = 'fail';
            state.messageTitle = action.payload.title;
            state.message = action.payload.message;
        },
        showSuccess(state, action) {
            state.request = false;
            state.outcome = 'success';
            state.messageTitle = action.payload.title;
            state.message = action.payload.message;
        },
        cancelError(state) {
            state.request = false;
            state.outcome = 'pending';
            state.message = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(updateNotificationsMobileNumber.pending, (state, action) => {
                state.request = true;
            })
            .addCase(updateNotificationsMobileNumber.fulfilled, (state, action) => {
                state.request = false;
                state.outcome = 'success';
                state.message = '';
            })
            .addCase(updateNotificationsMobileNumber.rejected, (state, action) => {
                const {payload} = action;
                state.request = false;
                state.outcome = 'fail';
                state.messageTitle = 'Error';
                //@ts-ignore
                state.message = payload.message;
            })
    },
});

export const {cancelError, showError, showSuccess} = updateSupplierNotificationsMobileNumberSlice.actions

export default updateSupplierNotificationsMobileNumberSlice.reducer;